import {EL} from "../util/DomUtils";
import {SearchableMenu} from "../DomMenu";
import {ClickSelectMode, GridCtrl} from "../GridCtrl";
import {app} from "../boot";

export async function showLegacySyncDialog() {
    const syncManager = app.db.getLegacyDocumentSyncManager();

    const root = EL('div', { style: {'user-select':'text','height':'400px'} });
    const grid = new GridCtrl(root, {
        initialCols: ['document','id','text',{key:'mt',expression:'mt.$date'},{key:'lmt',expression:'lmt.$date'},{key:'view_memo',expression:'"[local](meow:a:memo:doc:${document}#${id}) [remote](meow:a:memo:remotedoc:/pb.pb/${document}#${id})"'}],
        settingsKey: 'uploadchangesgrid',
        selectOnClick: ClickSelectMode.Single,
        allowMultiSelect: true,
    });

    grid.setData((async function*() { return await syncManager.queryForUploadAll(undefined);  })()).then(function() {
        grid.addToSelection(grid.data);
    });
    const buttons = ["ICOdisk_multiple.png Upload Selected", "Remove Selected", "Cancel"];
    const result = await SearchableMenu.show([], {
        customElement: Promise.resolve(root), center: false, width: 500,
        title: 'ICO14cd779f14b567f8dba95de31efe3926597a1fc6d28e1593f1802b8cbab24713',
        buttons: buttons,
        //buttonMode: 'below',
        backdrop: true,
    });

    if (result === 'ICOdisk_multiple.png Upload Selected') {
        await syncManager.uploadAllChanges(grid.selectedItems);
    }

    if (result === 'Remove Selected') {
        await syncManager.removeFromSyncQueue(grid.selectedItems);
        app.toast(`${grid.selectedItems.length} items removed from sync queue`)
    }
}